export const CELL_SELECTION_CONFIG_TYPES = {
  CELL_SELECTION_ENABLED: 'CELL_SELECTION_ENABLED',
  CELL_SELECTION_DISABLED: 'CELL_SELECTION_DISABLED'
};

/**
 * A single selected cell, resolved from the positional selection model into the
 * row + column identity a consumer needs to act on it. Handed to a
 * `CellSelectionAction`'s `onAction` / `isAvailable` / `getUnavailableReason`.
 */

/**
 * A consumer-provided action shown in the floating cell-selection menu, after
 * the built-in Copy action. FDT renders each action as a segment of a
 * Trellis-primary split button (icon + label).
 */

export const cellSelectionDisabled = {
  type: CELL_SELECTION_CONFIG_TYPES.CELL_SELECTION_DISABLED
};
export function isCellSelectionEnabled(config) {
  return config.type === CELL_SELECTION_CONFIG_TYPES.CELL_SELECTION_ENABLED;
}